import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  const handleCustomize = () => {
    localStorage.setItem('cookieConsent', 'customized');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <h3>Cookie-Einstellungen</h3>
          <p>
            Wir verwenden Cookies und ähnliche Technologien, um Ihnen die beste Erfahrung auf unserer Website zu bieten. 
            Diese helfen uns, die Nutzung zu analysieren und unseren Service zu verbessern. 
            Weitere Informationen finden Sie in unserer <Link to="/privacy-policy">Datenschutzerklärung</Link>.
          </p>
        </div>
        <div className="cookie-buttons">
          <button onClick={handleAccept} className="cookie-accept">
            Alle akzeptieren
          </button>
          <button onClick={handleCustomize} className="cookie-customize">
            Anpassen
          </button>
          <button onClick={handleDecline} className="cookie-decline">
            Ablehnen
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;